module.exports = __webpack_public_path__ + "media/images/workplace/xmas-notification-icon-09599144e7b86116a31cb69566c6dadb.svg";